
import api from "../../../../api/axios";

/**
 * Get Title & Escrow cost calculation from backend.
 * @param {Object} payload - Required body data for calculation
 * @param {Object} params - Optional params { mainid, userid, companyid }
 * @returns {Promise<Object>} API response data
 */

export const getCityStateZipCode = async (payload) => {
  try {
    const res = await api.get(`/get-city-state-for-zip?zip=${encodeURIComponent(payload.zip)}`);
    return res.data;
  } catch (error) {
    // If backend returns a structured error body (e.g., 400 for invalid ZIP),
    // pass it through so callers can show a friendly message.
    if (error?.response?.data) {
      return error.response.data;
    }
    throw error;
  }
};


export const getTitleEscrowCosts = async (payload, params = {}) => {
  try {
    const res = await api.post(`/buyer-title-escrow-costs`, payload);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getStateSettings = async (params = {}) => {
  try {
    const res1 = await api.get(`/state-setting`, { params });


    // const res2 = await api.post(`/closing-county`, { stateid: 5, countyid: 204, state: "California", county: "Los Angeles", zipcode: "" });
    return res1.data;
    // return res2.data;
  } catch (error) {
    throw error;
  }
};

export const getCountySettings = async (params = {}) => {
  try {
    const res = await api.get(`/county-setting`, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getNationalSettings = async (params = {}) => {
  // console.log("getNationalSettings() params:", JSON.stringify(params));
  try {
    const res = await api.get(`/national`, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Create new Buyer Calculator record
export const createBuyerCalculator = async (formData) => {
  try {
    const res = await api.post("/buyer", formData);
    return res.data;
  } catch (error) {
    console.error("createBuyerCalculator error:", error);
    throw error;
  }
};

// ✅ Update existing Buyer Calculator record
export const updateBuyerCalculator = async (id, formData) => {
  try {
    const res = await api.put(`/buyer/${id}`, formData);
    return res.data;
  } catch (error) {
    console.error("updateBuyerCalculator error:", error);
    throw error;
  }
};

// ✅ Fetch all Buyer Calculator records
export const getAllBuyerCalculators = async () => {
  try {
    const res = await api.get("/buyer");
    return res.data;
  } catch (error) {
    console.error("getAllBuyerCalculators error:", error);
    throw error;
  }
};

// ✅ Fetch one record by ID
export const getBuyerCalculator = async (id) => {
  try {
    const res = await api.get(`/buyer/${id}`);
    return res.data;
  } catch (error) {
    console.error("getBuyerCalculator error:", error);
    throw error;
  }
};

// ✅ Delete record by ID
export const deleteBuyerCalculator = async (id) => {
  try {
    const res = await api.delete(`/buyer/${id}`);
    return res.data;
  } catch (error) {
    console.error("deleteBuyerCalculator error:", error);
    throw error;
  }
};
